import { Injectable } from '@angular/core';
import { OroService } from '../oroservice';
import { AccountBalance } from '../shared/models/account-balance';
import { Absence } from './models/absence';
import { Question } from './models/question';
import { Task } from './models/task';

@Injectable()
export class DashboardService {
    constructor(private readonly oroService: OroService) {}

    public async getTasks(): Promise<Task[]> {
        return (await this.oroService.get<Task[] | null>('web/aufgaben')) ?? [];
    }

    public async getTaskCount(): Promise<number> {
        return await this.oroService.get<number>('web/aufgaben/count');
    }

    public async getQuestions(): Promise<Question[]> {
        return (await this.oroService.get<Question[] | null>('web/rueckfragen')) ?? [];
    }

    public async getQuestionCount(): Promise<number> {
        return await this.oroService.get<number>('web/rueckfragen/count');
    }

    public async getAccountBalance(): Promise<AccountBalance> {
        return await this.oroService.get<AccountBalance>('web/kunde/kontostand');
    }

    public async getAbsences(): Promise<Absence[]> {
        return (await this.oroService.get<Absence[] | null>('web/abwesenheit')) ?? [];
    }

    public async deleteAbsence(absence: Absence): Promise<string> {
        return await this.oroService.post<string>('web/abwesenheit/delete', absence);
    }

    public async markTaskDone(task: Task): Promise<Task> {
        return await this.oroService.post<Task>('web/aufgaben/done', task);
    }
}
